<div id="map-container" [ngSwitch]="currentMapStyle">
    <div *ngSwitchDefault>
        <div id="map"></div>
    </div>
</div>
<div class="container" *ngIf="showGeneralUserInfo" >
    <app-general-user (showGeneralUserInfoChange)="handleShowGeneralUserInfoChange($event)"></app-general-user>
</div>
